import React from "react";
import { IAutomation } from "../../interfaces/IAutomation";
import { IAutomationCategory } from "../../interfaces/IAutomationCategory";
import { IOfferState } from "../../interfaces/IOfferState";
import { IProjectState } from "../../interfaces/IProjectState";
import { ITaskState } from "../../interfaces/ITaskState";
import { IBillState } from "../../interfaces/IBillState";
import { Box, Card, CardContent, Grid, MenuItem, Typography } from "@mui/material";
import { CustomeTextField } from "../core/CustomeTextField";
import { AutomationMailCard } from "./AutomationMailCard";
import { IRole } from "../../interfaces/IRole";
import { ITaskPriority } from "../../interfaces/ITaskPriority";
import { ITaskType } from "../../interfaces/ITaskType";
import { AutomationTaskCard } from "./AutomationTaskCard";
import { AutomationChangeStateCard } from "./AutomationChangeStateCard";

export interface IProps {
    automation: IAutomation;
    setAutomation: Function;
    automationCategoryArray: IAutomationCategory[];
    offerStateArray: IOfferState[];
    projectStateArray: IProjectState[];
    taskStateArray: ITaskState[];
    billStateArray: IBillState[];
    roleArray: IRole[];
    //
    taskPriorityArray: ITaskPriority[];
    taskTypeArray: ITaskType[];
}

export const getEmptyAutomation = (): IAutomation => {
    return {
        is_activ: true,
        AutomationCategory: 1,
        AutomationChangeStateArray: [],
        AutomationMailArray: [],
        AutomationTaskArray: [],
        BillState: null,
        id: -1,
        OfferState: null,
        position: 1,
        ProjectState: 1,
        TaskState: null,
        title: "",
    };
};

export const AutomationEdit: React.FC<IProps> = ({
    automation,
    setAutomation,
    automationCategoryArray,
    offerStateArray,
    projectStateArray,
    taskStateArray,
    billStateArray,
    roleArray,
    //
    taskPriorityArray,
    taskTypeArray,
}) => {
    return (
        <>
            <Box sx={{ mt: 2 }} />
            <Grid container spacing={2}>
                <Grid item xs={2}>
                    <CustomeTextField
                        label="Aktiv"
                        attr="is_activ"
                        object={automation}
                        setObject={setAutomation}
                        type="boolean"
                    />
                </Grid>
                <Grid item xs={4}>
                    <CustomeTextField
                        label="Bereich"
                        attr="AutomationCategory"
                        object={automation}
                        setObject={(updatedAuto: IAutomation) =>
                            setAutomation({
                                ...updatedAuto,
                                TaskState: updatedAuto.AutomationCategory === 3 ? 1 : null,
                                ProjectState: updatedAuto.AutomationCategory === 1 ? 1 : null,
                                OfferState: updatedAuto.AutomationCategory === 2 ? 1 : null,
                                BillState: updatedAuto.AutomationCategory === 4 ? 10 : null,
                            })
                        }
                        type="select"
                    >
                        {automationCategoryArray.map((cat) => (
                            <MenuItem key={`select-send-category-${cat.id}`} value={cat.id}>
                                {cat.automationCategory}
                            </MenuItem>
                        ))}
                    </CustomeTextField>
                </Grid>
                <Grid item sm={6}>
                    <CustomeTextField
                        label="Titel"
                        attr="title"
                        object={automation}
                        setObject={setAutomation}
                        type="string"
                    />
                </Grid>

                <Grid item xs={6}>
                    <Typography sx={{ mt: 1 }}>Automatisierung auslösen beim Wechsel in den Status:</Typography>
                </Grid>
                <Grid item xs={6}>
                    {automation.AutomationCategory === 1 ? (
                        <CustomeTextField
                            label="Status"
                            attr="ProjectState"
                            object={automation}
                            setObject={setAutomation}
                            type="select"
                        >
                            {projectStateArray.map((x) => (
                                <MenuItem key={`select-auto-values-${x.id}`} value={x.id}>
                                    {x.projectState}
                                </MenuItem>
                            ))}
                        </CustomeTextField>
                    ) : automation.AutomationCategory === 2 ? (
                        <CustomeTextField
                            label="Status"
                            attr="OfferState"
                            object={automation}
                            setObject={setAutomation}
                            type="select"
                        >
                            {offerStateArray.map((x) => (
                                <MenuItem key={`select-auto-values-${x.id}`} value={x.id}>
                                    {x.offerState}
                                </MenuItem>
                            ))}
                        </CustomeTextField>
                    ) : automation.AutomationCategory === 3 ? (
                        <CustomeTextField
                            label="Status"
                            attr="TaskState"
                            object={automation}
                            setObject={setAutomation}
                            type="select"
                        >
                            {taskStateArray.map((x) => (
                                <MenuItem key={`select-auto-values-${x.id}`} value={x.id}>
                                    {x.taskState}
                                </MenuItem>
                            ))}
                        </CustomeTextField>
                    ) : automation.AutomationCategory === 4 ? (
                        <CustomeTextField
                            label="Status"
                            attr="BillState"
                            object={automation}
                            setObject={setAutomation}
                            type="select"
                        >
                            {billStateArray.map((x) => (
                                <MenuItem key={`select-auto-values-${x.id}`} value={x.id}>
                                    {x.billState}
                                </MenuItem>
                            ))}
                        </CustomeTextField>
                    ) : (
                        <>Fehler!</>
                    )}
                </Grid>

                <Grid item xs={12}>
                    {automation.id > -1 ? (
                        <AutomationMailCard
                            automation={automation}
                            setAutomation={setAutomation}
                            roleArray={roleArray}
                        />
                    ) : (
                        <Card variant="outlined">
                            <CardContent>Automatisierungen sind nach dem Erstellen verfügbar!</CardContent>
                        </Card>
                    )}
                </Grid>
                <Grid item xs={12}>
                    {automation.id > -1 ? (
                        <AutomationTaskCard
                            automation={automation}
                            setAutomation={setAutomation}
                            roleArray={roleArray}
                            taskPriorityArray={taskPriorityArray}
                            taskStateArray={taskStateArray}
                            taskTypeArray={taskTypeArray}
                        />
                    ) : (
                        <Card variant="outlined">
                            <CardContent>Automatisierungen sind nach dem Erstellen verfügbar!</CardContent>
                        </Card>
                    )}
                </Grid>
                <Grid item xs={12}>
                    {automation.id > -1 ? (
                        <AutomationChangeStateCard
                            automation={automation}
                            setAutomation={setAutomation}
                            autoCategory={automationCategoryArray}
                            billStateArray={billStateArray}
                            offerStateArray={offerStateArray}
                            projectStateArray={projectStateArray}
                            taskStateArray={taskStateArray}
                        />
                    ) : (
                        <Card variant="outlined">
                            <CardContent>Automatisierungen sind nach dem Erstellen verfügbar!</CardContent>
                        </Card>
                    )}
                </Grid>
            </Grid>
        </>
    );
};
